import { render, staticRenderFns } from "./DownloadDadosModal.vue?vue&type=template&id=55e45910&scoped=true&"
import script from "./DownloadDadosModal.vue?vue&type=script&lang=js&"
export * from "./DownloadDadosModal.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDadosModal.vue?vue&type=style&index=0&id=55e45910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e45910",
  null
  
)

export default component.exports